import { Box, SvgIcon, Typography } from '@mui/material';
import React from 'react';

export interface IFundTotalItemProps {
    title: string;
    icon: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {title?: string | undefined;}>;
    content: string;
}

const FundTotalItem: React.FC<IFundTotalItemProps> = ({ title, icon, content }) => {

    return <Box display={"flex"} flexGrow={1} gap={"22px"}>
        <SvgIcon component={icon} inheritViewBox sx={{width: "30px", height: "30px"}}/>
        <Box display={"flex"} flexDirection={"column"} gap={"3px"}>
            <Typography fontSize={"14px"} lineHeight={"17.07px"} fontWeight={"400"}>{title}</Typography>
            <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"}>{content}</Typography>
        </Box>
    </Box>
}

export default FundTotalItem;